/**
 * What the person is looking at, for the Report dialog to attach (ADR 0024 §2) and to find the help page for (docs/19).
 *
 * The tab is in the address since 2026-09-20 (`/studio`), so the route says that much by itself. Everything finer is
 * still state — the Studio's step, and which project it has open — so the route alone would not say where somebody
 * was when it went wrong. The shell and the Studio write here as those change, and the dialog reads it once, when it
 * opens. Identifiers only: the tab's name, the Studio's step and the project's id, never its title.
 */
type OnScreen = { screen: string | null; step: string | null; projectId: string | null };

const state: OnScreen = { screen: null, step: null, projectId: null };

export function setOnScreen(patch: { screen?: string | null; step?: string | null; projectId?: string | null }): void {
  if (patch.screen !== undefined) state.screen = patch.screen;
  if (patch.step !== undefined) state.step = patch.step;
  if (patch.projectId !== undefined) state.projectId = patch.projectId;
}

export function onScreen(): OnScreen {
  return { ...state };
}
